<template>
  <!-- 基本信息 -->
  <div class="w-full h-full pb-5">
    <el-row class="w-full custom-height overflow-y-auto overflow-x-hidden p-5">
      <el-col :span="24">
        <div>
          <div
            :key="ind"
            v-for="(item, ind) in sortAptitudeList"
            class="flex mb-10px rounded bg-color-main p-15px"
          >
            <div class="flex-1">
              <h5 class="font-bold ">
                <span v-show="!!item.isRequired" class="required-text--color text-base pr-2px"
                  >*</span
                >{{ `${ind + 1}.${item.title}` }}
              </h5>
              <div class="text-sm pl-2">{{ item.titleContent }}</div>
            </div>
            <span
              class="down-file--color w-200px text-right mr-20px cursor-pointer text-base"
              @click="downloadFile(item)"
              >下载示例</span
            >
          </div>
        </div>
      </el-col>
    </el-row>
    <div class="h-120px">
      <div class="mb-60px"></div>
      为了方便资料收集，您可以点击<span>下载人员入厂申报指引模板</span>收集数据，若您收集完相关资料，请按照以下要求导入模板数据，具体要求如下：将<span>人员入厂指引模板</span>文件放到PDF中，在【人员入厂指引】模块中进行导入
    </div>
    <div class="w-full flex justify-center items-center mt-5 mb-5">
      <el-button type="primary" size="small" @click="$emit('save')">已准备好</el-button>
      <el-button @click="$emit('back')" size="small">返回准备</el-button>
    </div>
  </div>
</template>

<script>
import {
  ContractorApi,
  ValuativeInformationApi,
  GuidanceConfigurationApi,
} from '@wiz-api/contractor-management'

import { FileApi } from '@wiz-api/file-management'

const contractorApi = new ContractorApi()
const valuativeInformationApi = new ValuativeInformationApi()

const guidanceConfigurationApi = new GuidanceConfigurationApi()
const fileApi = new FileApi()

export default {
  name: 'PersonEnterGuide',
  data() {
    return {
      sortAptitudeList: [],
    }
  },
  created() {
    this.getGuideList()
  },
  methods: {
    // 人员入厂指引列表
    async getGuideList() {
      const [err, res] = await guidanceConfigurationApi.contractorPersonnelGuidanceListQuery()
      if (!err) {
        this.sortAptitudeList = res
      }
    },
    async downloadFile({ fileId, fileName = '示例' }) {
      // returnType: 'Blob'
      const [err, res] = await fileApi.download(fileId, { returnType: 'Blob' })
      if (!err) {
        this.exportFile(res, fileName)
      }
    },
    // 下载文件
    exportFile(data, name) {
      const blob = new Blob([data], {
        type: 'application/pdf',
      })
      const blobUrl = window.URL.createObjectURL(blob)
      const templink = document.createElement('a')
      templink.style.display = 'none'
      templink.href = blobUrl
      templink.setAttribute('download', `${name}`)
      document.body.appendChild(templink)
      templink.click()
      document.body.removeChild(templink)
      window.URL.revokeObjectURL(blobUrl)
      this.$message({
        type: 'success',
        message: '下载成功!',
      })
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  height: 100%;
  padding-bottom: 0 !important;
}

::v-deep .custom-height {
  height: calc(100% - 230px);
}

.custom-title {
  color: var(--textColor);
}

::v-deep .upload-label {
  .el-form-item__label {
    float: none !important;
  }

  .el-form-item__content {
    margin-left: 0 !important;
  }
}

.required-text--color {
  color: #ff3a30;
}

.down-file--color {
  color: #acdbff;
}
</style>
